import React from 'react';
import classNames from '../../utils/classNames';

interface NotificationBadgeProps {
    number?: number;
    id?: string;
}

function NotificationBadge({ number = 0 }: NotificationBadgeProps) {
    return (
        <span
            className={classNames(
                'bg-warning relative -top-2.5 inline-flex h-5 w-5 items-center justify-center ',
                'rounded-full text-white before:content-[attr(data-number)] data-[number=0]:hidden'
            )}
            aria-label={gettext('NOTIFICATION_BADGE')}
            id="download-notification-bullet"
            data-number={number}
        />
    );
}

export default NotificationBadge;
